/** EmptyState component: a dashed placeholder for a screen with no data yet. */
import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  body: string;
  action?: ReactNode;
}

/**
 * Render a dashed empty-state block, used by a placeholder route until a
 * later lot implements the real screen.
 *
 * @param props - Title, body copy and an optional action element.
 * @returns The empty-state element.
 */
export function EmptyState({ title, body, action }: EmptyStateProps) {
  return (
    <div className="ui-empty-state">
      <p className="ui-label">{title}</p>
      <p>{body}</p>
      {action}
    </div>
  );
}
